export default __webpack_public_path__ + "static/media/Quicksand_Light.beba9db7.otf";